import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DispatchDevicePageComponent } from './dispatch-device-page.component';

const routes: Routes = [
  {
    path: 'dispatch-device-page',
    data: { name: 'Dispatch Device', isTab: false },
    component: DispatchDevicePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DispatchDevicePageRoutingModule1 {}
